export class Titel {
  title: string | null;
  subtitle: string | null;

  constructor(title = '', subtitle = null) {
    this.title = title
    this.subtitle = subtitle
  }
}
